import React from "react";

import CameraPosition from "./CameraPosition";

import Button, { ToggleButton } from "../base/Button";
import { VideoCameraIcon, XMarkIcon } from "@heroicons/react/24/outline";
import Tooltip from "../base/Tooltip";

const CameraInfoDisplay = () => {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Tooltip content="Camera Info" side="top" wrap>
      <ToggleButton isSelected={open} onChange={() => setOpen((open) => !open)}>
        <VideoCameraIcon className="w-4 h-4" />
      </ToggleButton>
      </Tooltip>
      {open && (
        <div className="CameraInfo absolute bottom-[36px] left-[-12px] text-xs flex items-center">
          <div className="px-2 py-1 items-center space-x-3 bg-qmdark-900/70 space-y-1">
            <div className="flex flex-row items-center">
              <h3 className="text-sm mr-auto">Camera Info</h3>
              <Button
                size="sq"
                variant="secondary"
                isQuiet
                onPress={() => setOpen(false)}
              >
                <XMarkIcon className="w-4 h-4" />
              </Button>
            </div>
            <CameraPosition />
          </div>
        </div>
      )}
    </>
  );
};

export default CameraInfoDisplay;
